module.exports = __webpack_public_path__ + "img/equipos-de-sala-gal-2-zoom.593d9f94.png";